<div *ngIf="innerHtml"
  [innerHTML]="innerHtml">
</div>
